import type { ChromeCopy } from './types'

export const hi: ChromeCopy = {
  appName: 'समझो',
  tagline: 'कागज़ समझो। अगला कदम जानो।',
  savedTitle: 'सेव किए कागज़',
  upcomingTitle: 'आने वाली आख़िरी तारीख़ें',
  markDone: 'काम हो गया',
  doneLabel: 'हो गया',
  deadlineCheckIn: '{n} सेव किए कागज़ की आख़िरी तारीख़ पास है। काम हो गया?',
  savedHint: 'ये सिर्फ़ इसी फ़ोन में हैं। कागज़ की फोटो और पूरा लिखा हुआ सेव नहीं होता, सिर्फ़ ज़रूरी जानकारी।',
  emptySaved: 'अभी कोई कागज़ सेव नहीं है।',
  clearAll: 'सब मिटाएँ',
  deleteItem: 'हटाएँ',
  aboutTitle: 'गोपनीयता और ज़रूरी जानकारी',
  privacyPoints: [
    'आपके कागज़ की फोटो और उसमें लिखी बातें इसी फ़ोन पर पढ़ी और समझाई जाती हैं। फोटो कहीं अपलोड नहीं होती।',
    'जब तक आप "सेव करें" न दबाएँ, कुछ भी सेव नहीं होता। "नया कागज़" दबाते ही पिछला कागज़ स्क्रीन और मेमोरी से हट जाता है।',
    'सेव करने पर सिर्फ़ ज़रूरी जानकारी (तारीख़, रकम, नंबर) इसी फ़ोन में रहती है — फोटो या पूरा लिखा हुआ नहीं। आप इसे कभी भी मिटा सकते हैं।',
    'इंटरनेट सिर्फ़ तीन कामों के लिए लगता है: पहली बार पढ़ने का टूल और आवाज़ें (समझो की अपनी साइट से) डाउनलोड करना, और अगर आप खुद कहें तो कागज़ की अंग्रेज़ी लाइनों का अनुवाद। अनुवाद के लिए भेजी गई लाइनें सेव नहीं होतीं, और आधार/फ़ोन जैसे नंबर पहले हटा दिए जाते हैं। तीसरा — सिर्फ़ जब आप सवाल पूछें: जवाब लिखने के लिए कागज़ में लिखी बातें और आपका सवाल समझो के सर्वर और एक AI सेवा (Groq) पर जाते हैं, आधार, पैन, फ़ोन और ईमेल पहले हटाकर; सिर्फ़ सरकारी वेबसाइटें देखी जाती हैं, और कुछ भी सेव नहीं होता। जो लाइनें अंग्रेज़ी में नहीं हैं, उनका अनुवाद एक AI सेवा (Groq) करती है।',
    'समझो में कोई विज्ञापन नहीं है। हम सिर्फ़ यह गिनते हैं कि कितने लोग ऐप खोलते हैं (Cloudflare Web Analytics, बिना कुकी के)। आपके कागज़ की कोई बात उसमें नहीं जाती और कहीं लॉग नहीं की जाती।'
  ],
  disclaimerTitle: 'यह सरकारी या कानूनी सलाह नहीं है',
  disclaimer: 'समझो एक स्वतंत्र मदद का टूल है, सरकारी वेबसाइट नहीं। यह कागज़ को आसान भाषा में बताता है, पर इसकी समझ आधिकारिक या कानूनी नहीं है। ज़रूरी बातें असली कागज़ या जारी करने वाले दफ़्तर से ज़रूर मिलाएँ।',
  contactTitle: 'कोई दिक्कत हो तो',
  contact: 'अगर कोई दिक्कत हो, तो हमसे इस ईमेल पर संपर्क करें:',
  freeTitle: 'पूरी तरह मुफ़्त',
  free: 'समझो ओपन-सोर्स टूल से चलता है: Tesseract से पढ़ना, और फ़ोन की अपनी आवाज़ या Meta की ओपन MMS आवाज़ों (CC BY-NC 4.0) से सुनाना। कोई खाता नहीं, कोई पैसा नहीं।',
  shareApp: 'व्हाट्सएप पर शेयर करें',
  installApp: 'ऐप फ़ोन में जोड़ें',
  offline: 'आप ऑफ़लाइन हैं',
  offlineHint: 'पहले इस्तेमाल हो चुका हो तो कागज़ बिना इंटरनेट भी पढ़ा जा सकता है।',
  shareAppMessage: 'सरकारी, बैंक या बिजली के कागज़ आसान भाषा में समझने और सुनने के लिए SAMJHO इस्तेमाल करें (मुफ़्त):\nhttps://samjho.pages.dev'
}
